import React from 'react';
import _ from 'lodash';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import general from '../../modulos/general'

const ImprFactEC = (listFactCl, list2, list, empresa, stImprFact) => {
  // console.log(listFactCl)
  // console.log(empresa)
  // console.log(list2)
  // console.log(list)
    if(stImprFact){
// GENERAR PDF
      let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
      // let widthDoc = (doc.internal.pageSize.width)
      // let heightDoc = (doc.internal.pageSize.height)
      // widthDoc para letter es 215.89999999999998 => se aprox a 216
      // heightDoc para letter es 279.4 => se aprox a 279
      let numFact = 0
      let cufe = ""
      let imprFact = false
      let contList = 0
      let fraProcFact = true
      

      let servidor = ""
      if(empresa.empresaArchFE==="codisert"){
        // servidor = "http://45.55.32.196:3000/"
        // servidor = "http://206.189.168.76:3000/"
        servidor = "https://foropticcodisertpruebas.com/api/"
      }
      if(empresa.empresaArchFE==="sinergy"){
        servidor = "http://159.223.189.147:3000/"
      }
      if(empresa.empresaArchFE==="conectic"){
        if(empresa.prefijoServ==="a"){
          servidor = "https://conecticstreamone.com/api/"
        }else{
          servidor = "https://conecticstreamtwo.com/api/"
        }
      }
      if(empresa.empresaArchFE==="supercable"){
        if(empresa.prefijoServ==="a"){
          servidor = "https://superfibra.tech/api/"
          // servidor = "http://64.227.28.91:3000/"
        }else{
          servidor = "https://supercable.tech/api/"
          // servidor = "http://68.183.108.193:3000/"
        }
      }
      if(empresa.empresaArchFE==="supercablebq"){
        if(empresa.prefijoServ==="a"){
          servidor = "http://159.203.107.108:3000/"
        }else{
          servidor = "http://159.223.189.38:3000/"
        }
      }




      // let nomB1 = "", nomB2 = ""

      document.body.style.cursor = 'wait'
      // listFactCl.forEach((elemento1, i) => {
      for(let i=0; i<listFactCl.length; i++){
        // setTimeout(()=>{
        // console.log("22", i)
        let elemento1 = listFactCl[i]
        // console.log(i, elemento1.listFact)
        contList += 1
        if(elemento1.listFact.numeroFra!==numFact){
          numFact = elemento1.listFact.numeroFra
          imprFact = true
        }else{
          imprFact = false
        }
        if(elemento1.listFact.cufe){
          cufe = elemento1.listFact.cufe
        }else{
          cufe = ""
        }

        if(imprFact){
          let elemento = elemento1.listFact
          let clientesFra = elemento1.clientesFra
          let codBarras = elemento1.listFact.codBarras

          //OJOOO si la fra no es del proc fact => en codProcFact viene el id del rango
          let modeloFactura = ""
          let indexSearchR = -1
          let indexSearchP = list2.findIndex( proceso => proceso.codProcFact===elemento.codProcFact )
          if(indexSearchP===-1){
            modeloFactura = empresa.modeloFactura
            indexSearchR = list.findIndex( rango => rango._id===elemento.codProcFact )
            fraProcFact = false
            if(indexSearchR===-1){
              if(elemento.codProcFact!=="ANULADA"){
                // alert(`La factura ${elemento.numeroFra} tiene asociado un proceso de facturación que no existe`)
                console.log("alert ", elemento.codProcFact, elemento.numeroFra, elemento.contrato)
                indexSearchR = list.length-1
              }
            }
          }else{
            indexSearchR = list.findIndex( rango => rango._id===list2[indexSearchP].idRangoFact )
            // modeloFactura = list2[indexSearchP].modeloFactura
            modeloFactura = empresa.modeloFacturaPF
          }
          // console.log(empresa, modeloFactura)
          let rangoFra = list[indexSearchR]

          let linea1Obs = ""
          let linea2Obs = ""
          // let rangoIniFin = ""
          let linea3Obs = ""

          let linea1DNN = ""
          let linea2DNN = ""
          let linea2DNN_B = ""
          // console.log(clientesFra)
          if(clientesFra.direccion.descrTipoVia1){
            // if(contList===1){
            //   nomB1 = clientesFra.dirmayor.ciudades.zonas.barrios.nombreBarrio
            // }else{
            //   nomB2 = clientesFra.dirmayor.ciudades.zonas.barrios.nombreBarrio
            // }

            linea1DNN = clientesFra.direccion.descrTipoVia1?clientesFra.direccion.descrTipoVia1:""
            linea1DNN += clientesFra.direccion.numeroTipoVia1?" " + clientesFra.direccion.numeroTipoVia1:""
            linea1DNN += clientesFra.direccion.descrTipoVia2?" " + clientesFra.direccion.descrTipoVia2:""
            linea1DNN += clientesFra.direccion.numeroTipoVia2?" " + clientesFra.direccion.numeroTipoVia2:""
            linea1DNN += clientesFra.direccion.numeroTipoVia2F?" " + clientesFra.direccion.numeroTipoVia2F:""
            linea1DNN += clientesFra.direccion.descrTipoUnd1?" " + clientesFra.direccion.descrTipoUnd1:""
            linea1DNN += clientesFra.direccion.numeroTipoUnd1?" " + clientesFra.direccion.numeroTipoUnd1:""
            linea1DNN += clientesFra.direccion.descrTipoUnd2?" " + clientesFra.direccion.descrTipoUnd2:""
            linea1DNN += clientesFra.direccion.numeroTipoUnd2?" " + clientesFra.direccion.numeroTipoUnd2:""
            linea1DNN = linea1DNN.substr(0, 40)
            
            linea2DNN = clientesFra.dirmayor.ciudades.nombreCiudad?clientesFra.dirmayor.ciudades.nombreCiudad:""
            linea2DNN += clientesFra.dirmayor.ciudades.zonas.barrios.nombreBarrio?" - " + clientesFra.dirmayor.ciudades.zonas.barrios.nombreBarrio:""
            linea2DNN = linea2DNN.substr(0, 40)
            linea2DNN_B = clientesFra.dirmayor.ciudades.zonas.barrios.nombreBarrio?clientesFra.dirmayor.ciudades.zonas.barrios.nombreBarrio:""
            linea2DNN_B = linea2DNN_B.substr(0, 40)
          }
          let nombreCli = `${clientesFra.nombreCliente} ${clientesFra.apellidoCliente}`
          nombreCli = nombreCli.substr(0, 40)
          let nitcc = clientesFra.numeroDoc?clientesFra.numeroDoc:""

          let telefonos = ""
          if(clientesFra.telefono1){
            telefonos += clientesFra.telefono1 + " "
          }
          if(clientesFra.telefono2){
            telefonos += clientesFra.telefono2 + " "
          }
          if(clientesFra.telefono3){
            telefonos += clientesFra.telefono3 + " "
          }

          let movColecc = [], movColeccOrd = []
          if(!elemento.detalleFact){
            console.log(elemento)
            console.log("no existe detalle")
            console.log(elemento.contrato)
          }
          // let valorFacturaServ = elemento.valorFactura
          elemento.detalleFact.forEach((elemento2, ii) => {
            let argsUpd = []
            if(elemento2.tipo==="IF"){
              argsUpd = ({descripcion: `${elemento2.nombreResumido} - ${elemento2.concepto} (${elemento2.porcImpto}%)`,
                      valor: elemento2.valor, consecEnFra: elemento2.consecEnFra, tipo: elemento2.tipo})
            }else{
              argsUpd = ({descripcion: `${elemento2.concepto} - ${elemento2.periodo}`, 
                      valor: elemento2.valor, consecEnFra: elemento2.consecEnFra, tipo: elemento2.tipo})
            }
            // if(elemento2.codigoServicio===elemento2.nombreResumido){
            //   valorFacturaServ -= elemento2.valor
            // }
            // console.log(argsUpd)
            movColeccOrd.push(argsUpd)
          })
          // console.log(movColeccOrd)
          movColeccOrd = _.orderBy(movColeccOrd, ['consecEnFra', 'tipo'], ['asc', 'desc'])
          movColeccOrd.forEach((elemento3, ii) => {
            let argsUpd = []
            argsUpd.push(elemento3.descripcion)
            // argsUpd.push('$' + Intl.NumberFormat().format(elemento3.valor))
            argsUpd.push('$' + general.formatNum(elemento3.valor.toString()))

            movColecc.push(argsUpd)
          })
  // console.log(movColecc)
  //IMPRIMIR FACTURA MODELO 1 => BUENAVENTURA
          if(modeloFactura==="1"){
            // linea1Obs = "Esta factura se asimila en todos sus efectos a la letra de cambio según Art. 774 del C. C."
            // linea2Obs = rangoFra.observaciones
            // rangoIniFin = `${rangoFra.factInicial} - ${rangoFra.factFinal}`
            // linea3Obs = `RESPONSABLE DE IVA - Formulario ${rangoFra.numResolucion} . Autorización de Numeración ${rangoIniFin}`
            linea1Obs = "RESPONSABLE DE IVA - Factura electrónica de venta relacionada con el CUFE"
            linea2Obs = cufe
            linea3Obs = rangoFra.observaciones

            let imgSource = new Image();
            imgSource.src = "images/logocliente.jpeg";
            doc.convertStringToImageData(imgSource)
            // doc.addImage(imgSource, 'PNG', 12, 12, 66, 20, 'logo');
            doc.addImage(imgSource, 'PNG', 12, 12, 66, 20);

            doc.setFontSize(10);
            doc.setFontType("Normal");
            doc.setFontStyle("italic");
            doc.text(empresa.empresaRazonSocial, 40, 33, 'center')

            doc.setFontSize(8);
            doc.setFontType("normal");
            doc.text(`NIT. ${empresa.empresaNit}`, 40, 37, 'center')
            doc.text(`${empresa.empresaDir} ${empresa.empresaTel}`, 40, 40, 'center')
        
            doc.setDrawColor("green")
            doc.lines([[70,0],[0,32],[0-70,0]], 80,10, [1,1], 'S', true)
            doc.line(80, 18, 150, 18)
            doc.line(80, 26, 150, 26)
            doc.line(80, 34, 150, 34)
            doc.setFontSize(12);
            doc.setFillColor("green")
            doc.lines([[35,0],[0,8],[0-35,0]], 80,10, [1,1], 'F', true)
            doc.setTextColor("white")
            doc.setFontType("bold");
            doc.text("CONTRATO:", 82, 15)
            // doc.setFontType("bold");
            doc.setTextColor("green")
            doc.setFontSize(8);
            doc.text(elemento.contrato, 132, 15, 'center')
            doc.text(`FACTURA ELECTRÓNICA DE VENTA`, 154, 13)
            doc.setFontSize(10);
            doc.text(`${elemento.numeroFra}`, 174, 17)
            // doc.text(`ESTADO DE CUENTA`, 154, 15)
            doc.setFontSize(6);
            doc.setTextColor("black")
            doc.text("CLIENTE", 82, 21)
            doc.text("NIT / CC", 82, 25)
            doc.text("DIRECCION", 82, 29)
            doc.text("MUNICIPIO - BARRIO", 82, 37)
            doc.text("FECHA FACTURA", 154, 21)
            doc.text("MES FACTURADO", 154, 29)
            doc.text("PAGUE HASTA", 154, 37)
            doc.setFontSize(8);
            doc.setFontType("normal");
            doc.text(nombreCli, 94, 21)
            doc.text(nitcc, 94, 25)
            doc.text(linea1DNN, 82, 33)
            doc.text(linea2DNN, 82, 41)
            doc.text(`${elemento.fechaFact.substr(0, 10)}`, 154, 25)
            doc.text(`${elemento.agno}-${elemento.mes}`, 154, 33)
            if(fraProcFact){
              if(empresa.pagueHastaSegunSaldo){
                if(elemento.valorFactura >= (clientesFra.cargoMensual * empresa.numMesesParaPH)){
                  doc.text(`INMEDIATO`, 154, 41)
                }else{
                  doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 154, 41)
                }
              }else{
                doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 154, 41)
              }
            }
        
            doc.setFillColor("blue")
            doc.lines([[140,0],[0,7],[0-140,0]], 10, 44, [1,1], 'F', true)
            // doc.lines([[196,0],[0,7],[0-196,0]], 10, 44, [1,1], 'F', true)

            doc.setFontSize(10);
            doc.setTextColor("white")
            doc.setFontType("bold");
            if(fraProcFact){
              doc.text("PAGUE HASTA:", 17, 49)
              if(empresa.pagueHastaSegunSaldo){
                if(elemento.valorFactura >= (clientesFra.cargoMensual * empresa.numMesesParaPH)){
                  doc.text(`INMEDIATO`, 56, 49, 'center')
                }else{
                  doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 56, 49, 'center')
                }
              }else{
                doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 56, 49, 'center')
              }
              // doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 56, 49, 'center')
            }
            doc.text("TOTAL A PAGAR:", 82, 49)
            doc.setLineWidth(1)
            doc.ellipse(125, 47.45, 12, 4)
            doc.setLineWidth(0)
            // doc.text('$' + Intl.NumberFormat().format(elemento.valorFactura), 126, 49, 'center')
            doc.text('$' + general.formatNum(elemento.valorFactura.toString()), 126, 49, 'center')
          
            doc.lines([[54,0],[0,32],[0-54,0]], 152,10, [1,1], 'S', true)
            doc.line(152, 18, 206, 18)
            doc.line(152, 26, 206, 26)
            doc.line(152, 34, 206, 34)
        
            doc.setFontSize(10);
            doc.setFillColor("green")
            
            doc.lines([[54,0],[0,7],[0-54,0]], 152, 44, [1,1], 'F', true)

            doc.setTextColor("white")
            doc.setFontType("bold");

            doc.lines([[196,0],[0,120],[0-196,0]], 10, 54, [1,1], 'S', true)
            doc.lines([[140,0],[0,120],[0-140,0]], 10, 54, [1,1], 'S', true)

            doc.text("IMPORTANTE:", 177, 49, 'center')
            doc.setDrawColor("black")
            doc.lines([[54,0],[0,120],[0-54,0]], 152, 54, [1,1], 'S', true)

            // var imgSource2 = new Image();
            // imgSource2.src = "images/logoclienteder.jpeg";
            // doc.convertStringToImageData(imgSource2)
            // //153= left, 55 = top, 52 = width, 117 = height
            // // doc.addImage(imgSource2, 'PNG', 153, 55, 52, 117, 'publicidadder');
            // doc.addImage(imgSource2, 'PNG', 153, 55, 52, 117);

            let textoder = ""
            // let textoder = `  Presentación de servicios

            // 1. Consultorio externo
            //   Manejo integral farmacológica y
            //   psicoterapéutica, contando con
            //   aproximadamente de 40 minutos por
            //   paciente realizando así:
            
            //     a. Psiquiatría general
            
            //       i. Valoración inicial
            //       ii. Intervención en crisis
            //       iii. Diagnostico por ejes CE10 y DSM
            //       iv. Tratamiento farmacológico
            //       v. Seguimiento del paciente
            
            // 2. Gerontopsiquiatria
            //   Prevención, diagnostico y tratamiento de los
            //   trastornos psíquicos de los adultos mayores,
            //   así como de fomentar la longevidad.
            
            // 3. Tratamiento de adicciones
            //   Manejo de trastornos relacionados con el
            //   consumo de alcohol, opiáceos, tabaco y
            //   otras sustancias psicoactivas.
            
            // 4. Psicoterapia familiar con orientación cognitiva
            //   conductual
            //   Identificación de roles, resolución de conflictos
            //   para mantener el equilibrio y la continuidad del
            //   proyecto familiar.
            
            // 5. Terapia grupal
            //   Interacción paciente-paciente,
            //   paciente-terapeuta,
            //   con el fin de realizar cambios en las
            //   conductas disfuncionales y estimulación
            //   del crecimiento y desarrollo de la
            //   personalidad.
            
            // Dra. María Fernanda Ferrer Orozco
            // Médico Psiquiatra
            // CENTRO MEDICO DEL PACIFICO 4to PISO
            // CONSULTORIO 305
            // CEL: 317 624 7128
            // Email: mferrer.md@gmail.com`
            
            doc.setTextColor("black")
            doc.setFontSize(6);
            doc.setFontType("normal");

            textoder = doc.splitTextToSize(textoder, 50, 2, 2)
            doc.text(textoder, 154, 58, 'left')

            doc.setFontSize(8);

            doc.lines([[196,0],[0,29],[0-196,0]], 10, 175, [1,1], 'S', true)
            doc.line(10, 186, 206, 186)
            doc.text(linea1Obs, 105, 178.3, 'center')
            doc.text(linea2Obs, 105, 181.3, 'center')
            doc.text(linea3Obs, 105, 184.3, 'center')

  // //SOLO PAR PRUEBAS CODIGO DE BARRAS
  // // var imgSourceCB1 = 'data:image/jpeg;base64,' + Base64.encode('images/logocliente.jpeg')



  // // let imgSourceCB1 = new Image();
  // // imgSourceCB1.src = codBarras;
  // // console.log(codBarras)
  // // doc.convertStringToImageData(imgSourceCB1)
  // // console.log(imgSourceCB1)
  // // doc.addImage(imgSourceCB1, 'PNG', 11, 150, 166, 44);

  // // console.log("11")
  // // let imgSource = new Image();
  // // imgSource.src = "images/logocliente.jpeg";
  // // doc.convertStringToImageData(imgSource)
  // // // doc.addImage(imgSource, 'PNG', 12, 12, 66, 20, 'logo');
  // // doc.addImage(imgSource, 'PNG', 12, 12, 66, 20);

  //         let imgSourceCB = new Image();
  //         imgSourceCB.src = codBarras;
  //         doc.convertStringToImageData(imgSourceCB)
  //         doc.addImage(imgSourceCB, 'PNG', 11, 96, 138, 44);
  //         doc.addImage(imgSourceCB, 'PNG', 11, 134, 138, 24);

  //         let imgSourceCB1 = new Image();
  //         imgSourceCB1.src = codBarras;
  //         doc.convertStringToImageData(imgSourceCB1)
  //         doc.addImage(imgSourceCB1, 'PNG', 11, 152, 166, 44);
  //         doc.addImage(imgSourceCB1, 'PNG', 11, 190, 166, 24);

  //         let imgSourceCB2 = new Image();
  //         imgSourceCB2.src = codBarras;
  //         doc.convertStringToImageData(imgSourceCB2)
  //         doc.addImage(imgSourceCB2, 'PNG', 6, 208, 205, 44);
  //         doc.addImage(imgSourceCB2, 'PNG', 6, 246, 205, 24);
  // //FIN SOLO PAR PRUEBAS CODIGO DE BARRAS

            let imgSourceCB = new Image();
            imgSourceCB.src = codBarras;
            doc.convertStringToImageData(imgSourceCB)
            // doc.addImage(imgSourceCB, 'PNG', 11, 156, 138, 14);
            doc.addImage(imgSourceCB, 'PNG', 11, 148, 138, 24);

            let observFra = ""
            if(fraProcFact){
              observFra = doc.splitTextToSize(list2[indexSearchP].observaciones, 194, 2, 2)
            }
            doc.setTextColor("#302b63")
            doc.text(observFra, 108, 189.4, 'center')
            doc.setTextColor("black")
            doc.setLineWidth(0)
          
            var imgSource3 = new Image();
            imgSource3.src = "images/logoclienteinf.jpeg";
            if(fraProcFact && list2[indexSearchP].imagenInf && list2[indexSearchP].imagenInf==="Imagen 2"){
              imgSource3.src = "images/logoclienteinf2.jpeg";
            }

            doc.convertStringToImageData(imgSource3)
            //10 = left, 205 = top, 196 = width, 62 = height
            // doc.addImage(imgSource3, 'PNG', 10, 205, 196, 62, 'publicidadinf');
            doc.addImage(imgSource3, 'PNG', 10, 205, 196, 62);
  // console.log(elemento.valorFacturado)
            let foot = []
            if(fraProcFact){
              foot = [["TOTAL FACTURADO", {content: '$' + general.formatNum(elemento.valorFacturado.toString()), styles: {halign: "right"}}],
              ["SALDO PENDIENTE", {content: '$' + general.formatNum((elemento.valorFactura - elemento.valorFacturado).toString()), styles: {halign: "right"}}],
              ["TOTAL A PAGAR", {content: '$' + general.formatNum(elemento.valorFactura.toString()), styles: {halign: "right"}}]]
            }else{
              foot = [["TOTAL FACTURADO", {content: '$' + general.formatNum(elemento.valorFacturado.toString()), styles: {halign: "right"}}],
              ["TOTAL A PAGAR", {content: '$' + general.formatNum(elemento.valorFactura.toString()), styles: {halign: "right"}}]]
            }

            doc.autoTable({startY: 54,
              tableLineColor: "black",
              tableLineWidth: 0.1,
              styles: {
                // font: 'Calibri',
                fontSize: 9,
                lineColor: "black",
                lineWidth: 0.1
              },
              headStyles: {
                fillColor: "#bdc3c7",
                textColor: "black",
                fontSize: 9
              },
              bodyStyles: {
                fillColor: "#E9E4F0",
                textColor: "black"
              },
              columnStyles: {
                1: {halign: "right"}
              },
              alternateRowStyles: {
                fillColor: "white",
                textColor: "black"
              },
              footStyles: {
                fillColor: "#bdc3c7",
                textColor: "black",
                fontSize: 9
              },
              head: [["Concepto", {content: "Valor", styles: {halign: "right"}}]],
              body: movColecc,
              foot: foot,
              margin: {top: 0, left: 10, right: 66},})
              // margin: {top: 0, left: 10, right: 10},})
              // console.log(servidor)
              // console.log(i, contList, listFactCl.length, fraProcFact)
              if(contList<=listFactCl.length){
                if(fraProcFact){
                  // console.log(i, elemento.numeroFra)
                  let nameDoc = `${elemento.numeroFra}.pdf`
                  doc.save(nameDoc)

                  // const pdfBlob = doc.output('blob');

                  // let formData = new FormData();
                  // formData.append('archivo', pdfBlob, nameDoc, { type: "application/pdf" });
                  // fetch(servidor + 'upload', {
                  //   method: 'POST',
                  //   body: formData,
                  //   headers: {
                  //     'carpeta': '/home/envcorreo/facturas',
                  //     // 'imgBD': navigation.route.params.data.imgAntes,
                  //     // 'imgNueva': nameDoc,
                  //   },
                  // })
                  // .then(() => console.log("288 Archivo enviado"))
                  // .catch(() => console.log("270 Archivo NO enviado"))
                }else{
                  doc.autoPrint({variant: 'non-conform'});
                  // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
                  // => UTILIZAR
                  const pdfBlob = doc.output('blob');
                  const url = URL.createObjectURL(pdfBlob);
                  window.open(url);
                }
                // doc.addPage()
              }
            }
            // console.log(modeloFactura)
  //FIN IMPRIMIR FACTURA MODELO 1 => BUENAVENTURA
  //IMPRIMIR FACTURA MODELO 2 => MANIZALES
            if(modeloFactura==="2"){
              // linea1Obs = "Esta factura se asimila en todos sus efectos a la letra de cambio según Art. 774 del C. C."
              // linea2Obs = rangoFra.observaciones
              // rangoIniFin = `${rangoFra.factInicial} - ${rangoFra.factFinal}`
              // linea3Obs = `RESPONSABLE DE IVA - Formulario ${rangoFra.numResolucion} . Autorización de Numeración ${rangoIniFin}`
              let widthDoc = (doc.internal.pageSize.width)
              let heightDoc = (doc.internal.pageSize.height)
              if(empresa.empresaArchFE==="supercable"&&clientesFra.factMod==="Modelo 2"){
                var imgSource3 = new Image();
                imgSource3.src = "images/logoclienteinf_sp.jpeg";
                doc.convertStringToImageData(imgSource3)
                doc.addImage(imgSource3, 'PNG', 5, 5, widthDoc-10, heightDoc-10);
              }
          
              linea1Obs = ""
              linea2Obs = ""
              linea3Obs = ""
      
              let fechaHoy = new Date()
              fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

              doc.setTextColor("black")
              doc.setFontSize(8);
              doc.setFontType("normal");

              doc.text(fechaHoy, 105, 47)
              doc.text(elemento.contrato, 150, 47, 'center')
              doc.text(clientesFra.numeroDoc, 180, 47, 'center')

              // doc.setFontSize(6);
              // doc.text(linea1Obs, 150, 53.3, 'center')
              // doc.text(linea2Obs, 150, 56.3, 'center')
              // doc.text(linea3Obs, 150, 59.3, 'center')

              doc.setFontSize(7);
              // doc.text("Factura de Venta No.: ", 100, 63)
              // doc.text(elemento.numeroFra, 135, 63)
              doc.text("Fecha:", 174, 56)
              doc.text(`${elemento.fechaFact.substr(0, 10)}`, 192, 56)
              doc.text("Nombre:", 100, 61)
              doc.text(nombreCli, 117, 61)
              doc.text("Mes facturado:", 174, 61)
              doc.text(`${elemento.agno}-${elemento.mes}`, 192, 61)

              doc.text("Dirección:", 100, 65)
              doc.text(linea1DNN, 117, 65)
              doc.text(linea2DNN, 117, 68)

              doc.text("Teléfono(s)::", 100, 72)
              doc.text(telefonos, 117, 72)

              // console.log(elemento.valorFacturado)
              let foot = []
              if(fraProcFact){
                foot = [
                ["SALDO PENDIENTE", {content: '$' + general.formatNum((elemento.valorFactura - elemento.valorFacturado).toString()), styles: {halign: "right"}}],
                ]
              }else{
                foot = [[]]
              }
    
              doc.autoTable({startY: 89,
                // tableLineColor: "white",
                // tableLineWidth: 0,
                styles: {
                  // font: 'Calibri',
                  fontSize: 8,
                  lineColor: "white",
                  // lineWidth: 0.1,
                },
                bodyStyles: {
                  fillColor: "white",
                  textColor: "black",
                },
                columnStyles: {
                  1: {halign: "right"}
                },
                alternateRowStyles: {
                  fillColor: "white",
                  textColor: "black",
                },
                footStyles: {
                  fillColor: "white",
                  textColor: "black",
                  fontSize: 8,
                  fontStyle: "normal"
                },
                body: movColecc,
                foot: foot,
                margin: {top: 0, left: 98, right: 18},
              })

              doc.setFontSize(7);
              if(fraProcFact){
                if(empresa.pagueHastaSegunSaldo){
                  if(elemento.valorFactura >= (clientesFra.cargoMensual * empresa.numMesesParaPH)){
                    doc.text(`PAGUESE DE INMEDIATO, SU SERVICIO SERÁ SUSPENDIDO`, 100, 132)
                    doc.text(`SI YA CANCELÓ HAGA CASO OMISO`, 115, 135)
                  }else{
                    doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 120, 132)
                  }
                }else{
                  doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 120, 132)
                }
              }
              doc.text('$' + general.formatNum(elemento.valorFactura.toString()), 187, 132, 'center')

              doc.setFontSize(7);

              let imgSourceCB = new Image();
              imgSourceCB.src = codBarras;
              doc.convertStringToImageData(imgSourceCB)
              // 11=Left, 156=Top, 138=Width, 14=Height
              // doc.addImage(imgSourceCB, 'PNG', 11, 156, 138, 14);
              // doc.addImage(imgSourceCB, 'PNG', 11, 148, 138, 24);
              // doc.addImage(imgSourceCB, 'PNG', 71, 210, 138, 24);
              // doc.addImage(imgSourceCB, 'PNG', 96, 210, 117, 24);

              doc.addImage(imgSourceCB, 'PNG', 11, 107, 80, 16);
              doc.addImage(imgSourceCB, 'PNG', 11, 251, 80, 16);

              doc.text("Nombre:", 105, 254)
              doc.text(nombreCli, 120, 254)
              doc.text("Dirección:", 105, 258)
              doc.text(linea1DNN, 120, 258)
              doc.text(linea2DNN, 120, 261)
              doc.text("Contrato:", 105, 265)
              doc.text(elemento.contrato, 120, 265)

              doc.setFontSize(10);
              doc.text('$' + general.formatNum(elemento.valorFactura.toString()), 195, 261, 'center')
              doc.setFontSize(7);

              // console.log(i, contList, listFactCl.length, fraProcFact)
              if(contList<=listFactCl.length){
                if(fraProcFact){
                  let nameDoc = `${elemento.numeroFra}.pdf`
                  doc.save(nameDoc)

                  // const pdfBlob = doc.output('blob');

                  // let formData = new FormData();
                  // formData.append('archivo', pdfBlob, nameDoc, { type: "application/pdf" });
                  // fetch(servidor + 'upload', {
                  //   method: 'POST',
                  //   body: formData,
                  //   headers: {
                  //     'carpeta': '/home/envcorreo/facturas',
                  //     // 'imgBD': navigation.route.params.data.imgAntes,
                  //     // 'imgNueva': nameDoc,
                  //   },
                  // })
                  // .then(() => console.log("288 Archivo enviado"))
                  // .catch(() => console.log("270 Archivo NO enviado"))
                }else{
                  doc.autoPrint({variant: 'non-conform'});
                  // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
                  // => UTILIZAR
                  const pdfBlob = doc.output('blob');
                  const url = URL.createObjectURL(pdfBlob);
                  window.open(url);
                }
                // doc.addPage()
              }
            }
            //FIN IMPRIMIR FACTURA MODELO 2 => MANIZALES
            //IMPRIMIR FACTURA MODELO 3 => CABLECAUCA
            if(modeloFactura==="3"&&empresa.empresaArchFE!=="conectic"){
              // linea1Obs = "Esta factura se asimila en todos sus efectos a la letra de cambio según Art. 774 del C. C."
              // linea2Obs = rangoFra.observaciones
              // rangoIniFin = `${rangoFra.factInicial} - ${rangoFra.factFinal}`
              // linea3Obs = `RESPONSABLE DE IVA - Formulario ${rangoFra.numResolucion} . Autorización de Numeración ${rangoIniFin}`
              linea1Obs = ""
              linea2Obs = ""
              linea3Obs = ""

              let fechaHoy = new Date()
              fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

              doc.setTextColor("black")
              doc.setFontSize(8);
              doc.setFontType("normal");

              doc.text(fechaHoy, 105, 42)
              doc.text(elemento.contrato, 150, 42, 'center')
              doc.text(clientesFra.numeroDoc, 180, 42, 'center')

              // doc.setFontSize(6);
              // doc.text(linea1Obs, 150, 53.3, 'center')
              // doc.text(linea2Obs, 150, 56.3, 'center')
              // doc.text(linea3Obs, 150, 59.3, 'center')

              doc.setFontSize(7);
              // doc.text("Factura de Venta No.: ", 100, 63)
              // doc.text(elemento.numeroFra, 135, 63)
              // doc.text("Fecha:", 174, 56)
              // doc.text(`${elemento.fechaFact.substr(0, 10)}`, 192, 56)
              doc.text("Suscriptor:", 100, 56)
              doc.text(nombreCli, 117, 56)
              // doc.text("Mes facturado:", 174, 61)
              // doc.text(`${elemento.agno}-${elemento.mes}`, 192, 61)

              doc.text("Dirección:", 100, 60)
              doc.text(linea1DNN, 117, 60)
              doc.text("Barrio:", 100, 64)
              doc.text(linea2DNN_B, 117, 64)

              // doc.text("Teléfono(s)::", 100, 72)
              // doc.text(telefonos, 117, 72)

              // console.log(elemento.valorFacturado)
              let foot = []
              if(fraProcFact){
                foot = [
                ["SALDO PENDIENTE", {content: '$' + general.formatNum((elemento.valorFactura - elemento.valorFacturado).toString()), styles: {halign: "right"}}],
                ]
              }else{
                foot = [[]]
              }

              doc.autoTable({startY: 89,
                // tableLineColor: "white",
                // tableLineWidth: 0,
                styles: {
                  // font: 'Calibri',
                  fontSize: 8,
                  lineColor: "white",
                  // lineWidth: 0.1,
                },
                bodyStyles: {
                  fillColor: "white",
                  textColor: "black",
                },
                columnStyles: {
                  1: {halign: "right"}
                },
                alternateRowStyles: {
                  fillColor: "white",
                  textColor: "black",
                },
                footStyles: {
                  fillColor: "white",
                  textColor: "black",
                  fontSize: 8,
                  fontStyle: "normal"
                },
                body: movColecc,
                foot: foot,
                margin: {top: 0, left: 98, right: 18},
              })

              doc.setFontSize(7);
              if(fraProcFact){
                if(empresa.pagueHastaSegunSaldo){
                  if(empresa.empresaArchFE==="sinergy"||empresa.numMesesParaPH===1){
                    let saldoPendiente = elemento.valorFactura - elemento.valorFacturado
                    if(saldoPendiente > (clientesFra.cargoMensual * (empresa.numMesesParaPH - 1))){
                      doc.text(`PAGO INMEDIATO`, 100, 132)
                    }else{
                      doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 120, 132)
                    }
                  }else{
                    if(elemento.valorFactura >= (clientesFra.cargoMensual * empresa.numMesesParaPH)){
                      doc.text(`PAGO INMEDIATO`, 100, 132)
                    }else{
                      doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 120, 132)
                    }
                  }
                }else{
                  doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 120, 132)
                }
              }
              doc.text('$' + general.formatNum(elemento.valorFactura.toString()), 187, 132, 'center')

              doc.setFontSize(7);

              let imgSourceCB = new Image();
              imgSourceCB.src = codBarras;
              doc.convertStringToImageData(imgSourceCB)
              // 11=Left, 156=Top, 138=Width, 14=Height
              // doc.addImage(imgSourceCB, 'PNG', 11, 156, 138, 14);
              // doc.addImage(imgSourceCB, 'PNG', 11, 148, 138, 24);
              // doc.addImage(imgSourceCB, 'PNG', 71, 210, 138, 24);
              // doc.addImage(imgSourceCB, 'PNG', 96, 210, 117, 24);

              doc.addImage(imgSourceCB, 'PNG', 8, 104, 80, 16);
              doc.addImage(imgSourceCB, 'PNG', 8, 262, 80, 16);

              doc.text("Nombre:", 96, 264)
              doc.text(nombreCli, 108, 264)
              doc.text("Dirección:", 96, 268)
              doc.text(linea1DNN, 108, 268)
              doc.text("CEDULA:", 156, 268)
              doc.text(clientesFra.numeroDoc, 171, 268)
              doc.text("Barrio:", 96, 272)
              doc.text(linea2DNN_B, 108, 272)

              doc.text("CODIGO:", 96, 276)
              doc.text(elemento.contrato, 108, 276)

              doc.text("FECHA:", 156, 276)
              if(fraProcFact){
                if(empresa.pagueHastaSegunSaldo){
                  if(empresa.empresaArchFE==="sinergy"||empresa.numMesesParaPH===1){
                    let saldoPendiente = elemento.valorFactura - elemento.valorFacturado
                    if(saldoPendiente > (clientesFra.cargoMensual * (empresa.numMesesParaPH - 1))){
                      doc.text(`PAGO INMEDIATO`, 171, 276)
                    }else{
                      doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 171, 276)
                    }
                  }else{
                    if(elemento.valorFactura >= (clientesFra.cargoMensual * empresa.numMesesParaPH)){
                      doc.text(`PAGO INMEDIATO`, 171, 276)
                    }else{
                      doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 171, 276)
                    }
                  }
                }else{
                  doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 171, 276)
                }
              }

              doc.setFontSize(10);
              doc.text('$' + general.formatNum(elemento.valorFactura.toString()), 200, 270, 'center')
              doc.setFontSize(7);

              // margin: {top: 0, left: 10, right: 10},})

              // console.log(i, contList, listFactCl.length, fraProcFact)
              if(contList<=listFactCl.length){
                if(fraProcFact){
                  let nameDoc = `${elemento.numeroFra}.pdf`
                  doc.save(nameDoc)

                  // const pdfBlob = doc.output('blob');

                  // let formData = new FormData();
                  // formData.append('archivo', pdfBlob, nameDoc, { type: "application/pdf" });
                  // fetch(servidor + 'upload', {
                  //   method: 'POST',
                  //   body: formData,
                  //   headers: {
                  //     'carpeta': '/home/envcorreo/facturas',
                  //     // 'imgBD': navigation.route.params.data.imgAntes,
                  //     // 'imgNueva': nameDoc,
                  //   },
                  // })
                  // .then(() => console.log("288 Archivo enviado"))
                  // .catch(() => console.log("270 Archivo NO enviado"))
                }else{
                  doc.autoPrint({variant: 'non-conform'});
                  // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
                  // => UTILIZAR
                  const pdfBlob = doc.output('blob');
                  const url = URL.createObjectURL(pdfBlob);
                  window.open(url);
                }
                // doc.addPage()
              }        
            }
            //FIN IMPRIMIR FACTURA MODELO 3 => CABLECAUCA
            // IMPRIMIR FACTURA Conectic
            // console.log(clientesFra)
            if(empresa.empresaArchFE==="conectic"){
              let widthDoc = (doc.internal.pageSize.width)
              let heightDoc = (doc.internal.pageSize.height)
              // console.log("modelo factura Conectic ancho", widthDoc, "alto", heightDoc)

              if(clientesFra.factMod==="Modelo 2"){
                var imgSource3 = new Image();
                imgSource3.src = "images/logoclienteinf_co.jpeg";
                doc.convertStringToImageData(imgSource3)
                doc.addImage(imgSource3, 'PNG', 5, 5, widthDoc-10, heightDoc-10);
              }

              linea1Obs = ""
              linea2Obs = ""
              linea3Obs = ""

              let fechaHoy = new Date()
              fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

              doc.setTextColor("black")
              doc.setFontSize(8);
              doc.setFontType("normal");

              if(fraProcFact){
                let fechaLimite = list2[indexSearchP].pagueHasta.substr(0, 10)
                let mes = list2[indexSearchP].mes
                doc.text(`Mes: ${mes}`, 20, 55)
                if(empresa.pagueHastaSegunSaldo){
                  let saldoPendiente = elemento.valorFactura - elemento.valorFacturado
                  if(saldoPendiente > (clientesFra.cargoMensual * (empresa.numMesesParaPH - 1))){
                    fechaLimite = "PAGO INMEDIATO"
                  }
                }
                doc.text(`Fecha pago oportuno: ${fechaLimite}`, 20, 61)
              }
              doc.text(`Fecha de impresión: ${fechaHoy}`, 20, 67)

              doc.text(`Suscriptor: ${nombreCli}`, 117, 25)
              doc.text(`Dirección: ${linea1DNN}`, 117, 33)
              doc.text(`Barrio: ${linea2DNN_B}`, 117, 37)

              doc.text(`Referencia de pago:`, 117, 71)
              doc.text(elemento.contrato, 182, 71)

              doc.setFontSize(7);

              // doc.text("Teléfono(s)::", 100, 72)
              // doc.text(telefonos, 117, 72)

              // console.log(elemento.valorFacturado)
              let foot = []
              if(fraProcFact){
                foot = [
                ["SALDO PENDIENTE", {content: '$' + general.formatNum((elemento.valorFactura - elemento.valorFacturado).toString()), styles: {halign: "right"}}],
                ]
              }else{
                foot = [[]]
              }

              doc.autoTable({startY: 41,
                // tableLineColor: "white",
                // tableLineWidth: 0,
                styles: {
                  // font: 'Calibri',
                  fontSize: 7,
                  lineColor: "white",
                  // lineWidth: 0.1,
                },
                bodyStyles: {
                  fillColor: "white",
                  textColor: "black",
                },
                columnStyles: {
                  1: {halign: "right"}
                },
                alternateRowStyles: {
                  fillColor: "white",
                  textColor: "black",
                },
                footStyles: {
                  fillColor: "white",
                  textColor: "black",
                  fontSize: 7,
                  fontStyle: "normal"
                },
                body: movColecc,
                foot: foot,
                margin: {top: 0, left: 115, right: 10},
              })

              doc.setFontSize(7);
              let imgSourceCB = new Image();
              imgSourceCB.src = codBarras;
              doc.convertStringToImageData(imgSourceCB)
              doc.addImage(imgSourceCB, 'PNG', 18, 190, 80, 16);
              // doc.addImage(imgSourceCB, 'PNG', 8, 262, 80, 16);

              doc.setFontSize(8);
              doc.text(`Suscriptor: ${nombreCli}`, 117, 193)
              doc.text(`Código: ${elemento.contrato}`, 117, 205)
              doc.text(`Cédula: ${clientesFra.numeroDoc}`, 117, 211)
              doc.text(`Fecha de impresión: ${fechaHoy}`, 117, 217)

              if(fraProcFact){
                let fechaLimite = list2[indexSearchP].pagueHasta.substr(0, 10)
                let mes = list2[indexSearchP].mes
                doc.text(`Mes: ${mes}`, 117, 223)
                if(empresa.pagueHastaSegunSaldo){
                  let saldoPendiente = elemento.valorFactura - elemento.valorFacturado
                  if(saldoPendiente > (clientesFra.cargoMensual * (empresa.numMesesParaPH - 1))){
                    fechaLimite = "PAGO INMEDIATO"
                  }
                }
                doc.text(`${fechaLimite}`, 125, 250)
              }

              doc.text('$' + general.formatNum(elemento.valorFactura.toString()), 180, 250)

              doc.setFontSize(7);
              
              // console.log(i, contList, listFactCl.length, fraProcFact)
              if(contList<=listFactCl.length){
                if(fraProcFact){
                  // console.log(i, elemento1.listFact, elemento1.listFact.cliente)
                  // console.log(i, elemento.numeroFra)
                  let nameDoc = `${elemento.numeroFra}.pdf`
                  if(elemento1.listFact.apellidoCliente!=="Enviar por correo"){
                    doc.save(nameDoc)
                  }else{
                    const pdfBlob = doc.output('blob');

                    let formData = new FormData();
                    formData.append('archivo', pdfBlob, nameDoc, { type: "application/pdf" });
                    console.log(servidor)
                    fetch(servidor + 'upload', {
                      method: 'POST',
                      body: formData,
                      headers: {
                        'carpeta': '/home/envcorreo/facturas',
                        // 'imgBD': navigation.route.params.data.imgAntes,
                        // 'imgNueva': nameDoc,
                      },
                    })
                    .then(() => console.log("288 Archivo enviado"))
                    .catch(() => console.log("270 Archivo NO enviado"))
                  }
                }else{
                  doc.autoPrint({variant: 'non-conform'});
                  // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
                  // => UTILIZAR
                  const pdfBlob = doc.output('blob');
                  const url = URL.createObjectURL(pdfBlob);
                  window.open(url);
                }
                // doc.addPage()
              } 
            }
            // FIN IMPRIMIR FACTURA Conectic
            // IMPRIMIR FACTURA Supercable BAQ
            // console.log(clientesFra)
            if(empresa.empresaArchFE==="supercablebq"){
              // linea1Obs = "Esta factura se asimila en todos sus efectos a la letra de cambio según Art. 774 del C. C."
              // linea2Obs = rangoFra.observaciones
              // rangoIniFin = `${rangoFra.factInicial} - ${rangoFra.factFinal}`
              // linea3Obs = `RESPONSABLE DE IVA - Formulario ${rangoFra.numResolucion} . Autorización de Numeración ${rangoIniFin}`

              let widthDoc = (doc.internal.pageSize.width)
              let heightDoc = (doc.internal.pageSize.height)
              console.log("907 modelo factura Supercable BAQ ancho", widthDoc, "alto", heightDoc)
              if(clientesFra.factMod==="Modelo 2"){
                var imgSource3 = new Image();
                imgSource3.src = "images/logoclienteinf_spbq.jpeg";
                doc.convertStringToImageData(imgSource3)
                doc.addImage(imgSource3, 'PNG', 5, 5, widthDoc-10, heightDoc-10);
              }

              linea1Obs = ""
              linea2Obs = ""
              linea3Obs = ""

              let fechaHoy = new Date()
              fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

              doc.setTextColor("black")
              doc.setFontSize(8);
              doc.setFontType("normal");

              doc.text(fechaHoy, 105, 46)
              doc.text(elemento.contrato, 142, 46, 'center')
              doc.text(clientesFra.numeroDoc, 180, 46, 'center')

              // doc.setFontSize(6);
              // doc.text(linea1Obs, 150, 53.3, 'center')
              // doc.text(linea2Obs, 150, 56.3, 'center')
              // doc.text(linea3Obs, 150, 59.3, 'center')

              doc.setFontSize(7);
              // doc.text("Factura de Venta No.: ", 100, 63)
              // doc.text(elemento.numeroFra, 135, 63)
              // doc.text("Fecha:", 174, 56)
              // doc.text(`${elemento.fechaFact.substr(0, 10)}`, 192, 56)
              doc.text("Suscriptor:", 104, 60)
              doc.text(nombreCli, 121, 60)
              // doc.text("Mes facturado:", 174, 61)
              // doc.text(`${elemento.agno}-${elemento.mes}`, 192, 61)

              doc.text("Dirección:", 104, 64)
              doc.text(linea1DNN, 121, 64)
              doc.text("Barrio:", 104, 68)
              doc.text(linea2DNN_B, 121, 68)

              // doc.text("Teléfono(s)::", 100, 72)
              // doc.text(telefonos, 117, 72)

              // console.log(elemento.valorFacturado)
              let foot = []
              if(fraProcFact){
                foot = [
                ["SALDO PENDIENTE", {content: '$' + general.formatNum((elemento.valorFactura - elemento.valorFacturado).toString()), styles: {halign: "right"}}],
                ]
              }else{
                foot = [[]]
              }

              doc.autoTable({startY: 108,
                // tableLineColor: "white",
                // tableLineWidth: 0,
                styles: {
                  // font: 'Calibri',
                  fontSize: 8,
                  lineColor: "white",
                  // lineWidth: 0.1,
                },
                bodyStyles: {
                  fillColor: "white",
                  textColor: "black",
                },
                columnStyles: {
                  1: {halign: "right"}
                },
                alternateRowStyles: {
                  fillColor: "white",
                  textColor: "black",
                },
                footStyles: {
                  fillColor: "white",
                  textColor: "black",
                  fontSize: 8,
                  fontStyle: "normal"
                },
                body: movColecc,
                foot: foot,
                margin: {top: 0, left: 100, right: 18},
              })

              doc.setFontSize(7);
              if(fraProcFact){
                if(empresa.pagueHastaSegunSaldo){
                  if(empresa.numMesesParaPH===1){
                    let saldoPendiente = elemento.valorFactura - elemento.valorFacturado
                    if(saldoPendiente > (clientesFra.cargoMensual * (empresa.numMesesParaPH - 1))){
                      doc.text(`PAGO INMEDIATO`, 102, 147)
                    }else{
                      doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 124, 147)
                    }
                  }else{
                    if(elemento.valorFactura >= (clientesFra.cargoMensual * empresa.numMesesParaPH)){
                      doc.text(`PAGO INMEDIATO`, 102, 147)
                    }else{
                      doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 124, 147)
                    }
                  }
                }else{
                  doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 124, 147)
                }
              }
              doc.text('$' + general.formatNum(elemento.valorFactura.toString()), 185, 147, 'center')

              doc.setFontSize(7);

              let imgSourceCB = new Image();
              imgSourceCB.src = codBarras;
              doc.convertStringToImageData(imgSourceCB)
              // 11=Left, 156=Top, 138=Width, 14=Height
              // doc.addImage(imgSourceCB, 'PNG', 11, 156, 138, 14);
              // doc.addImage(imgSourceCB, 'PNG', 11, 148, 138, 24);
              // doc.addImage(imgSourceCB, 'PNG', 71, 210, 138, 24);
              // doc.addImage(imgSourceCB, 'PNG', 96, 210, 117, 24);

              // doc.addImage(imgSourceCB, 'PNG', 8, 104, 80, 16);
              doc.addImage(imgSourceCB, 'PNG', 110, 176, 80, 16);

              doc.text("Nombre:", 12, 248)
              doc.text(nombreCli, 24, 248)
              doc.text("Dirección:", 12, 252)
              doc.text(linea1DNN, 24, 252)
              doc.text("CEDULA:", 70, 248)
              doc.text(clientesFra.numeroDoc, 81, 248)
              doc.text("Barrio:", 12, 256)
              doc.text(linea2DNN_B, 24, 256)

              doc.text("CODIGO:", 12, 260)
              doc.text(elemento.contrato, 24, 260)

              doc.text("FECHA:", 70, 252)
              if(fraProcFact){
                if(empresa.pagueHastaSegunSaldo){
                  if(empresa.empresaArchFE==="sinergy"||empresa.numMesesParaPH===1){
                    let saldoPendiente = elemento.valorFactura - elemento.valorFacturado
                    if(saldoPendiente > (clientesFra.cargoMensual * (empresa.numMesesParaPH - 1))){
                      doc.text(`PAGO INMEDIATO`, 81, 252)
                    }else{
                      doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 81, 252)
                    }
                  }else{
                    if(elemento.valorFactura >= (clientesFra.cargoMensual * empresa.numMesesParaPH)){
                      doc.text(`PAGO INMEDIATO`, 81, 252)
                    }else{
                      doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 81, 252)
                    }
                  }
                }else{
                  doc.text(`${list2[indexSearchP].pagueHasta.substr(0, 10)}`, 81, 252)
                }
              }

              doc.setFontSize(10);
              doc.text('$' + general.formatNum(elemento.valorFactura.toString()), 115, 256, 'center')
              doc.setFontSize(7);

              // console.log(i, contList, listFactCl.length, fraProcFact)
              if(contList<=listFactCl.length){
                if(fraProcFact){
                  // console.log(i, elemento.numeroFra)
                  let nameDoc = `${elemento.numeroFra}.pdf`
                  doc.save(nameDoc)

                  // const pdfBlob = doc.output('blob');

                  // let formData = new FormData();
                  // formData.append('archivo', pdfBlob, nameDoc, { type: "application/pdf" });
                  // fetch(servidor + 'upload', {
                  //   method: 'POST',
                  //   body: formData,
                  //   headers: {
                  //     'carpeta': '/home/envcorreo/facturas',
                  //     // 'imgBD': navigation.route.params.data.imgAntes,
                  //     // 'imgNueva': nameDoc,
                  //   },
                  // })
                  // .then(() => console.log("288 Archivo enviado"))
                  // .catch(() => console.log("270 Archivo NO enviado"))
                }else{
                  doc.autoPrint({variant: 'non-conform'});
                  // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
                  // => UTILIZAR
                  const pdfBlob = doc.output('blob');
                  const url = URL.createObjectURL(pdfBlob);
                  window.open(url);
                }
                // doc.addPage()
              }
            }
            // FIN IMPRIMIR FACTURA Supercable BAQ
          }
          // }, 60000)
        }
        // })
        document.body.style.cursor = 'default'
      }

      return true
  }

export default ImprFactEC